module.exports = __webpack_public_path__ + "img/logo.026f792d.webp";